<div class="offline-report-modal">
  <div class="modal-header">
    <h2>Download offline report</h2>
    <button class="close-btn" aria-label="Close dialog" (click)="cancel()">
      <img src="../../../../../../assets/report_v2/close_big.svg" alt="close" />
    </button>
  </div>

  <hr class="divider" />

  <div class="modal-body">
    <p class="description">
      You are about to download an offline version of the originality report.
      This report the document, highlights, sources, and analysis results.
    </p>

    <div class="option-card">
      <input type="checkbox" class="checkbox-input" id="sentence-findings-checkbox"
        [(ngModel)]="includeSentenceFindings" aria-label="Include sentence-level findings"
        aria-describedby="sentence-findings-desc" />
      <div class="option-card-content">
        <span class="option-title">Include sentence-level findings</span>
        <span class="option-desc" id="sentence-findings-desc">
          Adds detailed, printable pages showing sentence-by-sentence similarity analysis
          for comprehensive review and documentation.
        </span>
      </div>
    </div>
  </div>

  <hr class="divider" />

  <div class="modal-footer">
    <button class="btn-secondary-md" (click)="cancel()">Cancel</button>
    <button class="btn-blue-filled-md" (click)="download()">Download</button>
  </div>
</div>